"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_error_1 = require("../model/api.error");
var uuid = require('uuid/v4');
var authService;
if (process.env.REACT_APP_PLATFORM === 'desktop') {
    authService = require('info-auth').authService;
}
var isServerEnv = process.env.REACT_APP_PLATFORM != 'desktop';
var getRestConfig = function (contentType, transactionId, authToken, provider) {
    var authProvider = provider ? provider : 'infoauth';
    var contentTypeConfig = function () {
        switch (contentType ? contentType : '') {
            case 'multipart':
                return 'multipart/form-data;  boundary=----WebKitFormBoundarytyE4wkKlZ5CQJVTG';
            default:
                return 'application/json';
        }
    };
    var config = {
        headers: {
            mediaType: 'json',
            'Content-Type': contentTypeConfig(),
            'aeTransactionId': transactionId,
            'authorization': authToken,
            'provider': authProvider
        }
    };
    if (process.env.NODE_ENV === 'development') {
        config.headers['app-key'] = process.env.APIKEY;
    }
    return config;
};
var login = function (url, data) { return __awaiter(void 0, void 0, void 0, function () {
    var result, standardPostData, mergedData, config, errResponse, err, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                standardPostData = {
                    client_id: 'kbyuFDidLLm280LIwVFiazOqjO3ty8KH',
                    redirect_uri: 'https://openidconnect.net/callback',
                    scope: 'openid profile email phone',
                    response_type: 'id_token token',
                    state: '4a3084576c3c48a36287120a675424fd8c4d94dc'
                };
                mergedData = Object.assign(data, standardPostData);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                config = getRestConfig('json', uuid(), '');
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(mergedData),
                        headers: config.headers
                    })];
            case 2:
                result = _a.sent();
                if (!!result.ok) return [3 /*break*/, 4];
                return [4 /*yield*/, result.json()];
            case 3:
                errResponse = _a.sent();
                console.log('error resonse ', errResponse);
                err = new api_error_1.ApiError(errResponse.message, errResponse);
                throw err;
            case 4: return [2 /*return*/, result.json()];
            case 5:
                e_1 = _a.sent();
                console.log(e_1);
                throw e_1;
            case 6: return [2 /*return*/];
        }
    });
}); };
var apiDesktop = {
    refresh: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = authServerUrl + '/v1/refresh';
                        return [4 /*yield*/, login(url, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    signIn: function (url, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, errResponse, err, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, authService.desktopAuthorization('openid profile email phone', "kbyuFDidLLm280LIwVFiazOqjO3ty8KH", data.userName, data.password)];
                    case 1:
                        result = _a.sent();
                        if (!(result.code == 403 || result.code == 422)) return [3 /*break*/, 3];
                        return [4 /*yield*/, result];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_2 = _a.sent();
                        console.log(e_2);
                        throw e_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    createActivityTracking: function (activityTrackingUrl, data, authToken, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var url, config, result, errResponse, err, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = activityTrackingUrl + '/v1/useractivitytrackings';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        config = getRestConfig('json', uuid(), authToken, provider);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(data),
                                headers: config.headers
                            })];
                    case 2:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, result.json()];
                    case 3:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 4: return [2 /*return*/, result.json()];
                    case 5:
                        e_3 = _a.sent();
                        throw e_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    signUp: function (authServerUrl, user) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/signUpUserAuth', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(user)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_4 = _a.sent();
                        throw e_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    signUpUserProfile: function (authServerUrl, user) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', user.aeTransactionId, '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/signUpUserProfile', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(user)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_5 = _a.sent();
                        throw e_5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    forgotPassword: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, config, errResponse, err, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/password/reset', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_6 = _a.sent();
                        if (e_6 instanceof Error) {
                            throw e_6;
                        }
                        throw new Error(result);
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    passwordReset: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/password', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_7 = _a.sent();
                        throw e_7;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    confirmSignUp: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', data.transactionId, '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/confirm', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_8 = _a.sent();
                        throw e_8;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    insertDefaultUserMapping: function (authServerUrl, userId, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', transactionId, '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/userMappings', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify({ 'userId': userId })
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_9 = _a.sent();
                        throw e_9;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    changePassword: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, errResponse, err, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, authService.updatePassword(data.userName, data.oldPassword, data.newPassword)];
                    case 1:
                        result = _a.sent();
                        if (!(result.code == 400)) return [3 /*break*/, 3];
                        return [4 /*yield*/, result];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_10 = _a.sent();
                        console.log(e_10);
                        throw e_10;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    resendVerificationCode: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/code/resend', {
                                method: 'PUT',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_11 = _a.sent();
                        throw e_11;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
};
var apiServer = {
    refresh: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = authServerUrl + '/v1/refresh';
                        return [4 /*yield*/, login(url, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    signIn: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, postData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = authServerUrl + '/v1/authorize';
                        postData = {
                            user_name: data.userName,
                            password: data.password
                        };
                        return [4 /*yield*/, login(url, postData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    createActivityTracking: function (activityTrackingUrl, data, authToken, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var url, config, result, errResponse, err, e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = activityTrackingUrl + '/v1/useractivitytrackings';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        config = getRestConfig('json', uuid(), authToken, provider);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(data),
                                headers: config.headers
                            })];
                    case 2:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, result.json()];
                    case 3:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 4: return [2 /*return*/, result.json()];
                    case 5:
                        e_12 = _a.sent();
                        throw e_12;
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    signUp: function (authServerUrl, user) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/signUpUserAuth', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(user)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_13 = _a.sent();
                        throw e_13;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    signUpUserProfile: function (authServerUrl, user) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', user.aeTransactionId, '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/signUpUserProfile', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(user)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_14 = _a.sent();
                        throw e_14;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    forgotPassword: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, config, errResponse, err, e_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/password/reset', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_15 = _a.sent();
                        if (e_15 instanceof Error) {
                            throw e_15;
                        }
                        throw new Error(result);
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    passwordReset: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/password', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_16 = _a.sent();
                        throw e_16;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    confirmSignUp: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', data.transactionId, '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/confirm', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_17 = _a.sent();
                        throw e_17;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    insertDefaultUserMapping: function (authServerUrl, userId, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', transactionId, '');
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/userMappings', {
                                method: 'POST',
                                headers: config.headers,
                                body: JSON.stringify({ 'userId': userId })
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_18 = _a.sent();
                        throw e_18;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    changePassword: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/userName/password', {
                                method: 'PUT',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result];
                    case 4:
                        e_19 = _a.sent();
                        throw e_19;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    resendVerificationCode: function (authServerUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var config, result, errResponse, err, e_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config = getRestConfig('json', uuid(), '');
                        console.log(' Headers :', config);
                        return [4 /*yield*/, fetch(authServerUrl + '/v1/user/code/resend', {
                                method: 'PUT',
                                headers: config.headers,
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, result.json()];
                    case 2:
                        errResponse = _a.sent();
                        console.log('error resonse ', errResponse);
                        err = new api_error_1.ApiError(errResponse.message, errResponse);
                        throw err;
                    case 3: return [2 /*return*/, result.json()];
                    case 4:
                        e_20 = _a.sent();
                        throw e_20;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
};
var api = isServerEnv ? apiServer : apiDesktop;
exports.default = api;
//# sourceMappingURL=api.js.map